import { useMsal } from '@azure/msal-react';
import { COMMUNICATION_ADMIN_GROUP_ID, COMMUNICATION_SUPERVISOR_GROUP_ID } from '../../../features.config';

/**
 * Whether the caller is a Communication Supervisor — a member of the supervisor group,
 * OR an Admin (admin implies supervisor, mirroring the backend CommunicationSupervisor
 * policy). Treats an unset/placeholder REACT_APP_CUSTOMERCARE_SUPERVISOR_GROUP_ID as
 * "not supervisor" (fail-closed) so an unconfigured group never grants access.
 */
export function useIsCommunicationSupervisor(): boolean {
  const { accounts } = useMsal();
  const groups =
    ((accounts[0]?.idTokenClaims as Record<string, unknown>)?.groups as string[]) ?? [];
  const isSupervisor = !!COMMUNICATION_SUPERVISOR_GROUP_ID && groups.includes(COMMUNICATION_SUPERVISOR_GROUP_ID);
  const isAdmin = !!COMMUNICATION_ADMIN_GROUP_ID && groups.includes(COMMUNICATION_ADMIN_GROUP_ID);
  return isSupervisor || isAdmin;
}
